import { useEffect } from 'react';
import { getMe } from 'services/users.service';
import { getMessageFromAxiosError } from 'modules/message-factory/message-factory';
import { useAlert } from 'context/AlertProvider';
import { useTerminalID } from 'hooks/useTerminalID';

export default function MePage() {
  const alert = useAlert();
  const { terminalID } = useTerminalID();

  useEffect(() => {
    (async () => {
      try {
        await getMe();
      } catch (error) {
        alert.current.error(getMessageFromAxiosError(error));
      }
    })();
  }, [alert]);

  return <pre>{JSON.stringify(terminalID || 'no terminal id', null, 2)}</pre>;
}
